/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PartnerContentVerification } from './partnerContentVerification';
import { Relay } from './relay';


export interface RelayDto { 
    relay?: Array<Relay>;
    contentVerifications?: Array<PartnerContentVerification>;
    totalCount: number;
}
